var map = {
	"./de/common.json": 89532,
	"./de/company.json": 74718,
	"./de/contacts.json": 89086,
	"./de/cookies-policy.json": 35399,
	"./de/footer.json": 40659,
	"./de/metatags.json": 62128,
	"./de/privacy-policy.json": 89383,
	"./de/projects.json": 32416,
	"./de/terms-conditions.json": 2758,
	"./en/common.json": 88332,
	"./en/company.json": 69254,
	"./en/contacts.json": 79400,
	"./en/cookies-policy.json": 26498,
	"./en/footer.json": 32094,
	"./en/metatags.json": 64513,
	"./en/privacy-policy.json": 4940,
	"./en/projects.json": 47305,
	"./en/terms-conditions.json": 79019,
	"./fr/common.json": 83868,
	"./fr/company.json": 47799,
	"./fr/contacts.json": 45042,
	"./fr/cookies-policy.json": 51614,
	"./fr/footer.json": 78191,
	"./fr/metatags.json": 4664,
	"./fr/privacy-policy.json": 26743,
	"./fr/projects.json": 85328,
	"./fr/terms-conditions.json": 16393,
	"./pt/common.json": 57692,
	"./pt/company.json": 14893,
	"./pt/contacts.json": 98687,
	"./pt/cookies-policy.json": 21640,
	"./pt/footer.json": 33091,
	"./pt/metatags.json": 73374,
	"./pt/privacy-policy.json": 55551,
	"./pt/projects.json": 81711,
	"./pt/terms-conditions.json": 69385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34001;